module.exports = __webpack_public_path__ + "media/application/images/ui/thumbs-down-red-6672a9426e64a1d30e7cb89779c702b4.svg";